<div class="flex-col gap-2 w-full bg-white p-4 lg:flex hidden shadow-sm z-20 sticky top-0">
  <div class="container lg:px-0">
    <iho-desktop-searchbox />
  </div>
</div>

<!-- sticky mobile header -->
<div class="sticky top-0 shadow-md z-20">
  <iho-mobile-searchbox class="flex flex-col"></iho-mobile-searchbox>

  <div class="py-2 container bg-white flex overflow-x-scroll x-scroll lg:hidden sticky">
    <button (click)="showFilters()"
      class="border border-solid {{ selectedFilterCount && selectedFilterCount > 0 ? 'border-blue-500' : 'border-metal-200'}} px-4 py-1 rounded-full flex justify-center items-center">
      <i class="ico-Filter text-xl mx-1 font-bold"></i>
      <span class="font-bold text-sm">فیلترها</span>
      <span class="bg-blue-500 text-white h-[20px] w-[20px] rounded-full mr-1"
        *ngIf="selectedFilterCount && selectedFilterCount > 0">{{selectedFilterCount}}</span>
    </button>
    <button (click)="openSortTemplate()"
      class="border border-solid border-metal-200 px-4 py-1 rounded-full flex justify-center items-center mx-2">
      <i class="ico-Sort text-2xl mx-1 font-bold"></i>
      <span class="font-bold text-sm whitespace-nowrap">مرتب سازی</span>
    </button>
    <button (click)="showFilters(0)"
      class="border border-solid border-metal-200 px-4 py-1 rounded-full flex justify-center items-center mx-2">

      <span class="font-bold text-sm whitespace-nowrap"> قیمت </span>
    </button>
    <button (click)="showFilters(3)"
      class="border border-solid border-metal-200 px-4 py-1 rounded-full flex justify-center items-center mx-2">

      <span class="font-bold text-sm whitespace-nowrap"> نوع اقامتگاه</span>
    </button>

  </div>
</div>

<!-- pb-[12.5rem] md:pb-32 lg:pb-24 -->
<div class="flex flex-col gap-6 mb-4" id="main-search-res">
  <div class="container lg:px-0 pt-6 hidden lg:block" *ngIf="navigatorVal">
    <ng-container *ngIf="searchResult?.Breadcrumb;else noBreadcrumb">
      <iho-plp-breadcrumb [JsonBreadcrumb]="searchResult?.Breadcrumb" [searchName]="searchResult?.Search?.SearchBox" />
    </ng-container>
    <ng-template #noBreadcrumb>
      <iho-skeleton height="1.5rem" width="30rem" class="rounded-full mx-2" />
    </ng-template>
  </div>


  <div class="container lg:px-0 grid  gap-6 pt-6 md:pt-0 relative"
    [ngClass]="ecolodge ? 'lg:grid-cols-1' : 'lg:grid-cols-4'">
    <div class="hidden lg:block col-span-1 " *ngIf="!ecolodge && navigatorVal">
      <iho-filters-sidebar-desktop [dataSource]="filtersData" [mapUrlMain]="searchResult?.MapUrl"
        (removeDesktopFilters)="removeFilters(true)" />
    </div>


    <div class="col-span-4 lg:col-span-3 flex flex-col gap-4 mt-5">
      <section id="cardsWrapper" class="w-full flex flex-col items-stretch gap-4" #cardsWrapper>
        <div class="flex">
          <div [ngClass]="!ecolodge ? 'w-full' : 'lg:w-3/4'">
            <iho-plp-page-header [dataSource]="searchResult?.PageTitle" [prevPageLoading]='prevPageLoading' />
            <!-- <ng-template #noPageTitle>
                  <iho-skeleton height="2rem" width="10rem" class="rounded-full mx-2" />
                </ng-template> -->

            <div class="lg:block hidden">
              <iho-sort-filter-desktop (selectedItemSort)="selectedItemSortFilter($event)" />
            </div>
            <div class="w-full lg:flex items-center hidden mt-8" *ngIf="ecolodge">
              <span class="text-sm whitespace-nowrap">فیلتر ها :</span>
              <ul class="flex items-center" *ngIf="cards?.length;else nofilterData">
                <ng-container *ngFor="let item of filtersData; let index = index">
                <li [ngClass]="filterActive(item.Key)"
                 *ngIf="item.Items.length"  class="mr-3 relative px-3 py-1 rounded-full border border-solid  cursor-pointer flex items-center whitespace-nowrap">
                  <ng-container [ngSwitch]="item.Key">
                    <ng-container *ngSwitchCase="'labelsAccomodate'">
                      <i class="ico-tag text-lg" (click)="openFilterDialog(index)"></i>
                    </ng-container>
                    <ng-container *ngSwitchCase="'price'">
                      <i class="ico-dollar text-lg" (click)="openFilterDialog(index)"></i>
                    </ng-container>
                  </ng-container>
                  <span *ngIf="filterCount(item.Key) != ''"
                    class="badge absolute flex justify-center items-center top-[-10px] left-[-10px] h-[22px] w-[22px] rounded-full bg-blue-500 text-white text-xs">
                    {{filterCount(item.Key)}}
                  </span>
                  <span class="text-sm mr-2 pl-1" (click)="openFilterDialog(index)">{{filterTitle(item.Key)}}</span>
                  <span *ngIf="filterRemove(item.Key)" (click)="removeFilter(item.Key,$event)"
                    class="ico-Close border-r border-solid border-blue-500 pr-1"></span>


                </li>
                
                </ng-container>
              </ul>
              <ng-template #nofilterData>
                <ng-container *ngIf="prevPageLoading; else nothing">
                  <iho-skeleton height="1.5rem" width="8rem" class="rounded-full mx-2" />
                  <iho-skeleton height="1.5rem" width="8rem" class="rounded-full mx-2" />
                  <iho-skeleton height="1.5rem" width="8rem" class="rounded-full mx-2" />
                  <iho-skeleton height="1.5rem" width="8rem" class="rounded-full mx-2" />
                  <iho-skeleton height="1.5rem" width="8rem" class="rounded-full mx-2" />
                </ng-container>
                <ng-template #nothing>

                  <ul class="flex items-center">
                    <li *ngFor="let item of filtersData; let index = index" [ngClass]="filterActive(item.Key)"
                      class="mr-3 relative px-3 py-1 rounded-full border border-solid  cursor-pointer flex items-center whitespace-nowrap">

                      <ng-container [ngSwitch]="item.Key">
                        <ng-container *ngSwitchCase="'labelsAccomodate'">
                          <i class="ico-tag text-lg" (click)="openFilterDialog(index)"></i>
                        </ng-container>
                        <ng-container *ngSwitchCase="'price'">
                          <i class="ico-dollar text-lg" (click)="openFilterDialog(index)"></i>
                        </ng-container>
                      </ng-container>
                      <span *ngIf="filterCount(item.Key) != ''"
                        class="badge absolute flex justify-center items-center top-[-10px] left-[-10px] h-[22px] w-[22px] rounded-full bg-blue-500 text-white text-xs">
                        {{filterCount(item.Key)}}
                      </span>
                      <span class="text-sm mr-2 pl-1" (click)="openFilterDialog(index)">{{filterTitle(item.Key)}}</span>
                      <span *ngIf="filterRemove(item.Key)" (click)="removeFilter(item.Key,$event)"
                        class="ico-Close border-r border-solid border-blue-500 pr-1"></span>

                    </li>
                  </ul>
                </ng-template>
              </ng-template>

            </div>

          </div>
          <div class="w-1/4 mr-3 hidden lg:block" *ngIf="ecolodge">
            <iho-plp-map [mapUrl]="mapUrl"  [accommodation]="accommodation" />
          </div>

        </div>



        <div class="w-full hidden lg:block" *ngIf="searchResult?.Search?.SearchBox == 'کیش'">
          <a [href]="'https://shop.iranhotelonline.com/?utm_source=&utm_medium=shop&utm_campaign=bannerplp&utm_content=plpkish'"
            target="_blank" rel="nofollow">
            <img src="assets/images/shop-desk.svg" class="w-full">
          </a>
        </div>
        <div class="w-full block lg:hidden" *ngIf="searchResult?.Search?.SearchBox == 'کیش'">
          <a [href]="'https://shop.iranhotelonline.com/?utm_source=&utm_medium=shop&utm_campaign=bannerplp&utm_content=plpkish'"
            target="_blank" rel="nofollow">
            <img src="assets/images/shop.svg" class="w-full">
          </a>
        </div>


        <iho-plp-cards-skeleton [count]="ecolodge ? 8 : 24" *ngIf="(prevPageLoading)" />


        <!-- && ((!searchLoading) || currentPageIndex) -->
        <ng-container *ngIf="cards?.length">
          <div class="w-full grid gap-4"
            [ngClass]="ecolodge ? 'lg:grid-cols-4 grid-cols-1' : 'lg:grid-cols-1 grid-cols-1'">
            <iho-plp-card *ngFor="let cardData of cards; let index = index;" [id]="index" [dataSource]="cardData"
              [urlSearch]="searchResult?.Search" [lazyLoad]="index < 3" />
          </div>
        </ng-container>







        <!-- skeleton for when filter or date change -->
        <!-- <iho-plp-cards-skeleton *ngIf="searchLoading && !currentPageIndex" /> -->

        <iho-empty-view *ngIf="!nextPageLoading && !prevPageLoading && !cards?.length" />
        <!-- skeleton for nex page -->

        <iho-plp-cards-skeleton *ngIf="(cards?.length && nextPageLoading && currentPageIndex)"
          [count]="ecolodge ? 8 : 24" />

        <iho-pagination *ngIf="ecolodge && searchUiService.showPagination() && searchResult && searchResult.PageTitle"
          [count]="searchResult.PageTitle.CountHotel" (paginate)="onPaginate($event)"
          [currentPage]="queryParams['page'] ? (+queryParams['page']) : 4" />

      </section>

      <section #plpfaq>
        <iho-plp-faq *ngIf="faqs.length" [dataSource]="faqs" />
      </section>

      <section #relatedLinks>
        <iho-relatedlinks *ngIf="plpRelatedLinks" [dataSource]="plpRelatedLinks" />
      </section>
    </div>
  </div>


  <div class="container pt-6 md:hidden" *ngIf="!navigatorVal">
    <iho-plp-breadcrumb [JsonBreadcrumb]="searchResult?.Breadcrumb" />
  </div>
</div>

<a class="flex lg:hidden gap-2 items-center right-0 left-0 mx-auto max-w-[48%] justify-center rounded-xl bg-white py-1 px-3 z-10 border border-solid border-blue-500 text-blue-500 fixed bottom-[7rem]"
  (click)="goToMap()">
  <i class="ico-Location-line text-blue-500 text-xl"></i>
  <span class="font-bold border border-r">نمایش نقشه</span>
</a>
<ng-container *ngIf="!isDatepickerOpen() && navigatorVall">
  <iho-bottom-nav-mobile [userData]="userData()" />
</ng-container>


<ng-template #loadingTemplate>
  <iho-plp-cards-skeleton />
</ng-template>

<ng-template #emptyView>
  <iho-empty-view />
</ng-template>

<ng-container *ngIf="showSideFilter() && !navigatorVal">
  <iho-side-filters [dataSource]="filtersData" (reseSideFilters)="removeFilters(true)" [activeIndex]="filterClickedIndex"
    (FilterCountEmitter)="FilterCountEmitter($event)" />
</ng-container>

<ng-template #sort>
  <iho-sort-filter (closeBottomSheet)="closeSort($event)" (selectedItemSort)="selectedItemSortFilter($event)" />
</ng-template>

<ng-template #Range>
  <ng-container *ngIf="showPriceFilter()" class="flex-col">
    <div class="w-full text-center border border-bottom py-3">
      <i class="ico-Close float-right font-bold text-lg" (click)="closeSort($event)"></i>
      <h3>قیمت به ازای هرشب</h3>
    </div>
    <div class="mt-5 p-2">
      <iho-price-filter (checkedMinValue)="MinValue($event)" (checkedMaxValue)="MaxValue($event)"
        [dataSource]="rangeItems" [_maxValue]="maxPriceFilterInit!" [_minValue]="minPriceFilterInit!" />
    </div>
    <div class="w-full h-[1px] bg-gray-200 mt-2"></div>
    <div class="grid grid-cols-2 gap-2 !space-x-2 mt-2">
      <button mat-raised-button class="flex-1" color="primary" (click)="getDataForFilters()">اعمال فیلتر</button>
      <button mat-raised-button class="flex-1 !border !border-solid !border-blue-500"
        (click)="removeFilters(false, 'minPrice', 'maxPrice')">حذف فیلتر</button>
    </div>
  </ng-container>
</ng-template>
<ng-template #Residence>
  <div class="w-full text-center border border-bottom py-3">
    <i class="ico-Close float-right font-bold text-lg" (click)="closeSort($event)"></i>
    <h3 class="text-center">نوع اقامتگاه</h3>
  </div>
  <iho-residence-filter (checkedItemsEmit)="checkedResidence($event)" [typesFilters]="typesFilters"
    [dataSource]="residenceItems" />
  <div class="grid grid-cols-2 gap-2 !space-x-2 mt-2">
    <button mat-raised-button class="flex-1 !h-11" color="primary" (click)="getDataForFilters()">اعمال فیلتر</button>
    <button mat-raised-button class="flex-1 !border !border-solid !border-blue-500 !h-11"
      (click)="removeFilters(false,'types')">حذف فیلتر</button>
  </div>
</ng-template>